// TO ADD CURRENCY:
// 1. Add the currency to the fallback exchange rates
// 2. Add the currency to the grailCurrencies array
import accounting from 'accounting';
import axios from 'axios';
import { ExchangeRates, Prices, Talent } from './types';

export async function getExchangeRates(currencyFrom: string): Promise<ExchangeRates> {
    try {
        const response = await axios.get(`https://open.er-api.com/v6/latest/${currencyFrom}`);
        if (response?.data?.rates && typeof response.data.rates === 'object') {
            console.log(`RESPONSE`, response.data.rates);
            return response.data.rates;
        } else {
            console.error('Exchange Rates Error: Unexpected response format', response?.data);
            return {};
        }
    } catch (error) {
        console.error('Exchange Rates Error:', error);

        if (currencyFrom === 'USD') {
            console.warn('Exchange Rates Error: Using Backup Data');
            return {
                'USD': 1,
                'GBP': 0.76,
                'EUR': 0.86,
                'CAD': 1.4,
                'AUD': 1.54,
                'BRL': 5.2,
            }
        }

        return {};
    }
}

export interface GetLocalPriceParams {
    price: number,
    currencyFrom: string,
    currencyTo: string,
    rates: ExchangeRates,
    roundTo?: number
}

export function getLocalPrice({ price, currencyFrom, currencyTo, rates, roundTo = 25 }: GetLocalPriceParams) {
    if (currencyFrom === currencyTo) {
        return price;
    }
    if (!rates[currencyFrom] || !rates[currencyTo]) {
        console.error(`Missing rate for ${currencyFrom} or ${currencyTo}`);
        return price;
    }
    // Convert price to base (e.g. USD), then to target
    const priceInBase = price / rates[currencyFrom];
    const convertedPrice = priceInBase * rates[currencyTo];
    return Math.ceil(convertedPrice / roundTo) * roundTo;
}

export function getLocalPrices(talent: Talent, rates: ExchangeRates, currencyTo: string): Prices {
    const localPrices: Prices = {};

    if (talent.prices) {
        for (const priceEntry of Object.entries(talent.prices)) {
            localPrices[priceEntry[0] as keyof Prices] = getLocalPrice({
                price: priceEntry[1],
                currencyFrom: talent.currency || 'USD',
                currencyTo,
                rates,
            });
        }
    }

    return localPrices;
}

export const grailCurrencies = [
    { code: 'USD', label: 'USD', symbol: '$', flagUrl: 'https://flagcdn.com/w20/us.png', flag2x: 'https://flagcdn.com/w40/us.png' },
    { code: 'GBP', label: 'GBP', symbol: '£', flagUrl: 'https://flagcdn.com/w20/gb.png', flag2x: 'https://flagcdn.com/w40/gb.png' },
    { code: 'EUR', label: 'EUR', symbol: '€', flagUrl: 'https://flagcdn.com/w20/eu.png', flag2x: 'https://flagcdn.com/w40/eu.png' },
    { code: 'CAD', label: 'CAD', symbol: 'CA$', flagUrl: 'https://flagcdn.com/w20/ca.png', flag2x: 'https://flagcdn.com/w40/ca.png' },
    { code: 'AUD', label: 'AUD', symbol: 'AU$', flagUrl: 'https://flagcdn.com/w20/au.png', flag2x: 'https://flagcdn.com/w40/au.png' },
    { code: 'BRL', label: 'BRL', symbol: 'R$', flagUrl: 'https://flagcdn.com/w20/br.png', flag2x: 'https://flagcdn.com/w40/br.png' },
];

export function getCurrencySymbol(currencyCode: string) {
    return grailCurrencies.find((currency) => currency.code === currencyCode)?.symbol || '';
}

export function formatMoney(amount: number | undefined, currency: string, precision = 0) {
    if (amount == null) {
        return null;
    }
    return accounting.formatMoney(amount, getCurrencySymbol(currency), precision, ',', '.');
}